/* eslint-disable @angular-eslint/component-selector */

import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: 'restricted-search-callout',
    templateUrl: './restricted-search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RestrictedSearchCalloutComponent {
    readonly visible = input<boolean>(false);
    readonly type = input<RestrictedSearchCalloutType>(RestrictedSearchCalloutType.Warning);
    readonly header = input<string>('Notice');
    readonly text = input<string>('Search results are limited by datagroup access restrictions.');

    readonly cssClass = computed<string>(() => `bs-callout bs-callout-${this.type()} pull-right`);
}

export enum RestrictedSearchCalloutType {
    Info = 'primary',
    Warning = 'warning',
    Error = 'danger',
    Success = 'success',
}